import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// IMPORTANT - must precede the view route due to substring path match
export const dashboardEditRoute: InvariantJiraRoute = {
	name: 'dashboard-edit',
	path: '/jira/dashboards/:dashboardId(\\d+)/edit',
	query: ['maximized?'],
	exact: true,
};
